export const isPaymentPayloadNotEmpty = (
  paymentPayload: Record<string, unknown> | string | undefined
): boolean => {
  if (paymentPayload == null) {
    return false;
  }

  if (typeof paymentPayload === "string") {
    return paymentPayload.trim().length > 0;
  }

  return Object.keys(paymentPayload).length > 0;
};

export const getPaymentPayloadForRequest = (
  paymentPayload: Record<string, unknown> | string
): Record<string, unknown> => {
  if (typeof paymentPayload === "string") {
    return JSON.parse(paymentPayload) as Record<string, unknown>;
  }

  return paymentPayload;
};
